module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 2v28c0 1.106.894 2 2 2h2V0H2C.894 0 0 .894 0 2zm30-2H6v32h24c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-2.188 12.906l-4.604 4.978 1.8 6.004c.134.45.028.714-.236.714-.1 0-.224-.042-.372-.118L19 21.448l-5.342 3.032a.806.806 0 0 1-.366.12c-.268 0-.374-.27-.246-.718l1.744-5.996-4.6-4.978c-.362-.512-.19-.932.392-.934l5.262-.03L18.46 7.02c.146-.278.348-.42.54-.42.198 0 .394.142.542.422l2.618 4.924 5.26.03c.58 0 .754.42.392.93z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/journal-3.js
// module id = 1199
// module chunks = 14